import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// "Link this element to its entity's page" — carried by the generic
// DynamicApp* display elements (text / image). When Yes, the element
// resolves its bound entity's display page through the host-registered
// entity-page-link resolver (@bloglovin/inspire-engine .../Helpers/
// entity-page-links) and renders as a link to it: a Story title links to
// the story page, an Event title to the event page, a cover image to the
// detail page. Entities without a display page render unlinked.
export default class LinkToEntityPage extends BaseOption {
  static userInterfaceComponent = {
    label: "Link To Page",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  };

  static defaultValue = false;
}
